<template>
    <div id="center">
        <div id="map1" style="height:6.5rem;"></div>
        <div style="width: 1.5rem;position: absolute;top: 1.2rem">
            <div style="height: 1rem" v-for="(item, index) in cardData" :key="index">
                <dv-border-box-9>
                    <div style="display: flex;padding: 0.17rem 0.12rem">
                        <div>
                            <img src="../../../img/on_normal.png" style="width: 0.6rem;height: 0.6rem" v-if="item.name=='在线正常'">
                            <img src="../../../img/on_error.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='在线异常'">
                            <img src="../../../img/off_normal.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='离线正常'">
                            <img src="../../../img/off_error.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='离线异常'">
                            <img src="../../../img/un_state.png" style="width: 0.6rem;height: 0.6rem" v-else-if="item.name=='未投运'">
                        </div>
                        <div style="margin-top: 0.1rem;color: #5cd9e8">
                            <div>{{item.name}}</div>
                            <div style="margin-top: 0.1rem;font-weight: bold;text-align: center">{{item.val}}</div>
                        </div>
                    </div>
                </dv-border-box-9>

            </div>


        </div>
    </div>
</template>

<script>

  import echartMixins from "@/utils/resizeMixins";
  // 显示中国地图

  export default {
    props:{
      map: {
        type: Array
      },
      cardData: Array
    },
    data() {
      return {
        chart: null,
      };
    },
    mixins: [echartMixins],
    mounted() {
      this.draw();
    },
    methods: {
      draw() {
        // 基于准备好的dom，初始化echarts实例

        this.chart = this.$echarts.init(document.getElementById("map1"));
        // var dataMap =[
        //   {name: '北京',value: 100},{name: '天津',value: 100},
        //   {name: '上海',value: 200 },{name: '重庆',value: 200 },
        //   {name: '河北',value: 200},{name: '河南',value: 200 },
        //   {name: '云南',value: 200},{name: '辽宁',value: 200 },
        //   {name: '吉林',value: 200},{name: '福建',value: 200},
        //   {name: '贵州',value: 200 },{name: '广东',value: 200}
        // ];
        var dataMap = this.map
        var specialMap = [];
        // 对dataMap进行处理，使其可以直接在页面上展示
        for (var i = 0; i < specialMap.length; i++) {
          for (var j = 0; j < dataMap.length; j++) {
            if (specialMap[i] == dataMap[j].name) {
              dataMap[j].selected = true;
              break;
            }

          }
        }

        var option = {
          tooltip: {
            formatter: function (params) {
              let is_value =  isNaN(params.value)
              let value = 0

              if (!is_value){
                value = params.value
                console.log(value)
              }
              return '<p>' + params.name + '</p><p>设备数：'+value+'台</p>';
              // console.log('选择'+params.value)
              // if(params.value){
              //   _nums = params.value
              // }

            },
            backgroundColor: "#07304b",//提示标签背景颜色
            textStyle: { color: "#fff" } //提示标签字体颜色
          },
          series: [
            {
              name: '中国',
              type: 'map',
              mapType: 'china',
              zoom: 1.2,
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#00a0c9'
                  }
                },
                emphasis: { // 对应的鼠标悬浮效果
                  show: false,
                  textStyle: {
                    color: "#00a0c9"
                  }
                }
              },
              itemStyle: {
                normal: {
                  areaColor: '#07304b',
                  borderColor: '#0066ba',
                  shadowBlur: 10,
                  shadowColor: 'rgba(0,245,255,.5)',
                  // shadowOffsetX: 10,
                  // shadowOffsetY: 1,
                },
                emphasis: {
                  borderWidth: 0,
                  borderColor: '#0066ba',
                  areaColor: "#0494e1",
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              data: dataMap
            }
          ],
          dataRange: {
            x: '-1000 px', //图例横轴位置
            y: '-1000 px', //图例纵轴位置
            splitList: [
              {start: 1, end: 1000, label: '北京', color: '#00E5EE'},
              {start: 2, end: 20000, label: '天津', color: '#00E5EE'},
              // {start: 3, end: 3, label: '上海', color: '#feffdb'},
              // {start: 4, end: 4, label: '重庆', color: '#e0cee4'},
              // {start: 5, end: 5, label: '河北', color: '#fde8cd'},
              // {start: 6, end: 6, label: '河南', color: '#e4f1d7'},
              // {start: 7, end: 7, label: '云南', color: '#fffed7'},
              // {start: 8, end: 8, label: '辽宁', color: '#e4f1d7'},
              // {start: 9, end: 9, label: '黑龙江', color: '#e4f1d7'},
              // {start: 10, end: 10, label: '湖南', color: '#fffed7'},
              // {start: 11, end: 11, label: '安徽', color: '#fffed8'},
              // {start: 12, end: 12, label: '山东', color: '#dccee7'},
              // {start: 13, end: 13, label: '新疆', color: '#fffed7'},
              // {start: 14, end: 14, label: '江苏', color: '#fce8cd'},
              // {start: 15, end: 15, label: '浙江', color: '#ddceeb'},
              // {start: 16, end: 16, label: '江西', color: '#e4f1d3'},
              // {start: 17, end: 17, label: '湖北', color: '#fde8cd'},
              // {start: 18, end: 18, label: '广西', color: '#fde8cd'},
              // {start: 19, end: 19, label: '甘肃', color: '#fde8cd'},
              // {start: 20, end: 20, label: '山西', color: '#fffdd6'},
              // {start: 21, end: 21, label: '内蒙古', color: '#ddcfe6'},
              // {start: 22, end: 22, label: '陕西', color: '#fad8e9'},
              // {start: 23, end: 23, label: '吉林', color: '#fce8cd'},
              // {start: 1, end: 24000, label: '福建', color: '#FFFF00'},
              // {start: 25, end: 25, label: '贵州', color: '#fad8e8'},
              // {start: 26, end: 26, label: '广东', color: '#FFA500'},
              // {start: 27, end: 27, label: '青海', color: '#fad8e9'},
              // {start: 28, end: 28, label: '西藏', color: '#ddcfe6'},
              // {start: 29, end: 29, label: '四川', color: '#e4f1d5'},
              // {start: 30, end: 30, label: '宁夏', color: '#fefcd5'},
              // {start: 31, end: 31, label: '海南', color: '#fad8e9'},
              // {start: 32, end: 32, label: '台湾', color: '#fce8cd'},
              // {start: 33, end: 33, label: '香港', color: '#dc9bbb'},
              // {start: 34, end: 34, label: '澳门', color: '#e0f7cc'}
            ]
          }
        };


        this.chart.setOption(option);


      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>

<style lang="scss">


</style>
